export class HLine {
	//left
	public l: number;
	//y
	public y: number;
	//right
	public r: number;
	//extra
	public e: number;
	constructor(line : any) {
		if (line) {
			this.l = line.l;
			this.r = line.r;
			this.y = line.y;
			this.e = line.e ? line.e : 0;
		}
	}

}